import * as yup from 'yup';

export default yup.object().shape({
  advertiserId: yup.string().required('requiredAdvertiserMessage'),
  accountManagerIds: yup.array().required('requiredAccountManagers')
});
